import cinemaController from '../cinema/cinemaController';
import debug from '../qa/debug';

export default {
    injectCinema : (targetElement, htmlContent, eventMergeId) => {
        targetElement.innerHTML = htmlContent;

        return cinemaController(targetElement, false, eventMergeId)
            .isLoaded
            .catch((error) => {
                debug.log(error);
                targetElement.innerHTML = '';
                throw error;
            });
    }
};
